var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useRef, useEffect, forwardRef } from 'react';
const CustomScrollbar = forwardRef((props, ref) => {
    const { children, id, style, className, scrollTop, autoHeight, autoHide, maxHeight } = props, rest = __rest(props, ["children", "id", "style", "className", "scrollTop", "autoHeight", "autoHide", "maxHeight"]);
    const viewportRef = useRef(null);
    useImperativeHandle(ref, () => ({
        get scrollTop() {
            return viewportRef.current ? viewportRef.current.scrollTop : 0;
        },
        set scrollTop(value) {
            if (viewportRef.current) {
                viewportRef.current.scrollTop = value;
            }
        },
        scrollTo: (options) => {
            if (viewportRef.current) {
                viewportRef.current.scrollTo(options);
            }
        },
        getScrollElement: () => viewportRef.current
    }));
    useEffect(() => {
        if (scrollTop !== undefined && viewportRef.current) {
            viewportRef.current.scrollTo({
                top: scrollTop,
                behavior: 'smooth'
            });
        }
    }, [scrollTop]);
    const containerClass = "ui-custom-scrollbar-container";
    const viewportClass = "ui-custom-scrollbar-viewport";
    const autoHideClass = autoHide ? "autohide" : "";
    const heightModeClass = autoHeight ? "mode-auto-height" : "mode-full-height";
    // External styles (e.g., widths passed by the user) are applied to the outer container.
    const mergedContainerStyles = Object.assign(Object.assign({}, style), (autoHeight && maxHeight ? { maxHeight } : {}));
    return (
    /* OUTER LAYER: Handles only the layout */
    _jsxs("div", { id: id, className: `${containerClass} ${heightModeClass} ${className || ''}`, style: mergedContainerStyles, children: [_jsx("div", Object.assign({ ref: viewportRef, className: `${viewportClass} ${autoHideClass}`, style: autoHeight && maxHeight ? { maxHeight } : {} }, rest, { children: children })), _jsx("style", {})] }));
});
CustomScrollbar.displayName = 'CustomScrollbar';
export default CustomScrollbar;
